// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
// import moment from "moment";
// import { ExportPdfColor } from "../../../../../root/theme/exportColor";
// import eatprestoLogo from "../../../../../assets/images/logos/logo.png";
// import { convertDateTimeFormat } from "../../../../../utils/ConvertDateTimeFormat";

// /* Create a pdf file */
// export const handleDownloadPdf = (
//   scapeChange: string,
//   columns: any,
//   nodes: any,
//   filterDetails: any,
//   bodyLength: any,
// ) => {
//   const doc: any = new jsPDF(scapeChange === "p" ? "p" : "l");
//   const totalPagesExp = "{total_pages_count_string}";
//   const locationFilter = filterDetails.split("*")[0];
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const today = moment().format("MMM_Do_YY").toString();
//   let locationLength = 0;

//   if (!locationFilter.includes(",")) {
//     locationLength = 10;
//   }

//   /* If there is a image, insert it into the img variable. */
//   const img = new Image();
//   img.src = eatprestoLogo;

//   const columnLength: number = columns.length;

//   /* Create a pdf file. */
//   doc.autoTable({
//     columns: columns.map((col: any) => ({ ...col, dataKey: col.field })),
//     body: nodes,
//     startY: 58 + locationLength,
//     styles: {
//       align: "center",
//       fontSize: 8,
//       valign: "middle",
//       halign: "center",
//       borderRadius: "10px",
//     },
//     headStyles: {
//       fillColor: [ExportPdfColor.HeaderRowColor],
//       textColor: ["#ffffff"],
//       fontSize: 7,
//       valign: "middle",
//       halign: "center",
//     },
//     columnStyles: {
//       0: { fontStyle: "bold", halign: "left" },
//       [columnLength]: { halign: "right" },
//     },
//     alternateRowStyles: {
//       fillColor: [ExportPdfColor.OddRowColor],
//       textColor: ["#ffffff"],
//     },
//     tableLineWidth: 0.1,
//     // Change footer style.
//     willDrawCell: function (data: any) {
//       const rows = data.table.body;
//       if (data.row.index === rows.length - 1) {
//         doc.setFillColor(ExportPdfColor.green);
//         doc.setTextColor(255, 255, 255);
//       }
//     },

//     // Add topic and sub topics.
//     didDrawPage: function (data: any) {
//       let pageNumber = "Page " + doc.internal.getNumberOfPages();
//       // Change topic font size
//       doc.setFontSize(12);
//       doc.text("Presto Express Solutions", data.settings.margin.left, 12);
//       // Modify the marginLeft according to the scape.
//       doc.text("Reward Choices Report", data.settings.margin.left + 137, 12);

//       // Change main title font size
//       doc.setFontSize(16);
//       // Insert a topic for the first page only.
//       if (doc.internal.getNumberOfPages() === 1) {
//         /* Change the title according to the number of locations.
//         If the location size is increased, show presto express. if the location size is the one, show that location. */
//         doc.setTextColor("#32363E");
//         if (locationFilter.includes(",")) {
//         } else {
//           doc.text(
//             filterDetails
//               .split("*")[0]
//               .replace("Reward Choices Report for location/s:", ""),
//             pageWidth / 2,
//             36,
//             {
//               align: "center",
//             },
//           );
//         }

//         doc.setTextColor(0, 0, 0);
//         doc.text(
//           "Reward Choices Report",
//           pageWidth / 2,
//           36 + locationLength,
//           "center",
//         );
//         doc.setFontSize(10);

//         /* Change the sub title according to the number of locations.
//         If the location size is increased, show number of locations. if the location size is the one, show that location. */
//         let filterLocationsDetails = "";
//         if (locationFilter.split(",").length === 1) {
//           filterLocationsDetails =
//             "Reward Choices Report for " + locationFilter.split(",")[0];
//         } else {
//           filterLocationsDetails =
//             "Reward Choices Report for " +
//             locationFilter.split(",").length +
//             " Locations";
//         }

//         doc.text(
//           doc.splitTextToSize(filterLocationsDetails, 210 - 15 - 15),
//           pageWidth / 2,
//           44 + locationLength,
//           {
//             align: "center",
//           },
//         );

//         /* Set the start date and end date */
//         doc.text(
//           doc.splitTextToSize(
//             "Generated for the period of " + filterDetails.split("*")[1],
//             210 - 15 - 15,
//           ),
//           pageWidth / 2,
//           50 + locationLength,
//           {
//             align: "center",
//           },
//         );
//       }

//       // Total page number plugin only available in jspdf v1.0+
//       if (typeof doc.putTotalPages === "function") {
//         pageNumber = pageNumber + " of " + totalPagesExp;
//       }
//       doc.setFontSize(10);
//       /* Set page number */
//       let pageSize = doc.internal.pageSize;
//       const pageHeight = pageSize.height
//         ? pageSize.height
//         : pageSize.getHeight();
//       doc.text(pageNumber, data.settings.margin.left, pageHeight - 10);
//       doc.addImage(
//         img,
//         "JPEG",
//         data.settings.margin.left + 144,
//         pageHeight - 24,
//         40,
//         16,
//       );
//     },
//     /* Change the backgroundcolor in the row. */
//     didParseCell: function (data: any) {
//       const rows = data.table.body;
//       const isHeader = data.section === "head";
//       const isLastRow = data.row.index === rows.length - 1;

//       // ✅ Convert only 1st and 2nd columns to formatted datetime
//       if (!isHeader && (data.column.index === 0 || data.column.index === 1)) {
//         const cellValue = data.cell.raw;
//         if (cellValue) {
//           // Convert with moment to readable format
//           data.cell.text = convertDateTimeFormat(cellValue);
//         }
//       }

//       // ✅ (Keep your other color & alignment styling below)
//       if (data.section === "head") {
//         if (data.column.dataKey === "firstChosen") {
//           data.cell.styles.halign = "left";
//         } else if (data.column.dataKey === "uniqueCustomers") {
//           data.cell.styles.halign = "right";
//         }
//       }
//       if (data.column.index === 6) {
//         data.cell.styles.halign = "right";
//       }
//       if (data.row.index !== 0) {
//         if (data.row.raw.Method === "Total Payments") {
//           data.cell.styles.fillColor = [ExportPdfColor.green];
//           data.cell.styles.textColor = ["#ffffff"];
//         } else if (data.row.index + 1 >= bodyLength + 1) {
//           data.cell.styles.fillColor = [ExportPdfColor.purple];
//           data.cell.styles.textColor = ["#ffffff"];
//         } else {
//           if (data.row.index % 2 === 0) {
//             data.cell.styles.fillColor = [ExportPdfColor.OddRowColor];
//             data.cell.styles.textColor = ["#ffffff"];
//           } else {
//             data.cell.styles.fillColor = [ExportPdfColor.EvenRowColor];
//             data.cell.styles.textColor = ["#ffffff"];
//           }
//         }
//       }
//       if (data.row.index + 1 === rows.length) {
//         data.cell.styles.fontStyle = "bold";
//         if (data.column.index === 6) {
//           data.cell.styles.halign = "right";
//         }
//       }
//     },
//     margin: {
//       top: 30,
//       bottom: 30,
//     },
//   });

//   if (typeof doc.putTotalPages === "function") {
//     doc.putTotalPages(totalPagesExp);
//   }

//   doc.save(
//     `Reward_Choices_Report_${today}_${Math.floor(
//       100000 + Math.random() * 900000,
//     )}.pdf`,
//   );
// };

import { jsPDF } from "jspdf";
import "jspdf-autotable";
import _ from "lodash";
import moment from "moment";
import eatprestoLogo from "../../../../../assets/images/logos/logo.png";
import { ExportPdfColor } from "../../../../../root/theme/exportColor";

/**
 * Adds report header (title, subtitle, etc.)
 */
const handleConvertPdf = (doc: any, filterDetails: string) => {
  const locationFilter = filterDetails.split("*")[0];
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.autoTable({
    didDrawPage: (data: any) => {
      doc.setFontSize(12);
      doc.text("Presto Express Solutions", data.settings.margin.left, 12);
      doc.text("Reward Choices Report", data.settings.margin.left + 137, 12);

      doc.setFontSize(16);
      if (doc.internal.getNumberOfPages() === 1) {
        doc.setTextColor("#32363E");
        if (!locationFilter.includes(",")) {
          doc.text(
            filterDetails
              .split("*")[0]
              .replace("Reward choices report for location/s:", ""),
            pageWidth / 2,
            36,
            { align: "center" },
          );
        }

        doc.setTextColor(0, 0, 0);
        doc.text("Reward Choices Report", pageWidth / 2, 56, "center");
        doc.setFontSize(10);

        const filterLocationsDetails =
          locationFilter.split(",").length === 1
            ? "Reward Choices Report for " + locationFilter.split(",")[0]
            : "Reward Choices Report for " +
              locationFilter.split(",").length +
              " Locations";

        doc.text(
          doc.splitTextToSize(filterLocationsDetails, 210 - 30),
          pageWidth / 2,
          44,
          { align: "center" },
        );

        /* Set the start date and end date */
        doc.text(
          doc.splitTextToSize(
            "Generated for the period of " + filterDetails.split("*")[1],
            210 - 15 - 15,
          ),
          pageWidth / 2,
          49,
          {
            align: "center",
          },
        );
      }
    },
    margin: { top: 30, bottom: 30 },
  });
};

/**
 * Draws a single table block (section)
 */
const handleTableInfo = (
  key: string,
  doc: any,
  pdfHeader: any,
  nodes: any[],
  startY: number,
  lastIndex: number,
) => {
  const columnLength = pdfHeader.length;
  const totalPagesExp = "{total_pages_count_string}";

  doc.autoTable({
    columns: pdfHeader.map((col: any) => ({ ...col, dataKey: col.field })),
    body: nodes,
    showHead: "everyPage",
    startY,
    tableWidth: 180,
    styles: {
      align: "center",
      fontSize: 8,
      valign: "middle",
      halign: "center",
      borderRadius: "10px",
      minCellHeight: 12,
    },
    columnStyles: {
      0: { fontStyle: "bold", halign: "left", columnWidth: 180 / columnLength },
      1: { halign: "center", columnWidth: 180 / columnLength },
      2: { halign: "center", columnWidth: 180 / columnLength },
      3: { halign: "center", columnWidth: 180 / columnLength },
      4: { halign: "center", columnWidth: 180 / columnLength },
      5: { halign: "center", columnWidth: 180 / columnLength },
      6: { halign: "right", columnWidth: 180 / columnLength },
    },
    alternateRowStyles: {
      fillColor: [ExportPdfColor.HeaderRowColor],
      textColor: ["#ffffff"],
    },
    tableLineWidth: 0.1,

    didParseCell: (data: any) => {
      const rows = data.table.body;
      const { raw } = data.row;
      if (data.section === "head") {
        if (data.column.dataKey === "firstChosen") {
          data.cell.styles.halign = "left";
        } else if (data.column.dataKey === "uniqueCustomers") {
          data.cell.styles.halign = "right";
        }
      }
      if (data.column.index === 6) {
        data.cell.styles.halign = "right";
      }
      if (data.row.index !== 0) {
        if (data.row.index + 1 === rows.length) {
          data.cell.styles.fillColor = [ExportPdfColor.green];
          data.cell.styles.textColor = ["#ffffff"];
        } else {
          if (data.row.index % 2 === 0) {
            data.cell.styles.fillColor = [ExportPdfColor.OddRowColor];
            data.cell.styles.textColor = ["#ffffff"];
          } else {
            data.cell.styles.fillColor = [ExportPdfColor.EvenRowColor];
            data.cell.styles.textColor = ["#ffffff"];
          }
        }
      }
      if (data.row.index + 1 === rows.length) {
        data.cell.styles.fontStyle = "bold";
        if (data.column.index === 6) {
          data.cell.styles.halign = "right";
        }
      }
    },

    didDrawPage: (data: any) => {
      const eatprestoLogoImg = new Image();
      eatprestoLogoImg.src = eatprestoLogo;

      const totalPagesExp = "{total_pages_count_string}";
      let pageNumber = "Page " + doc.internal.getNumberOfPages();

      const pageHeight = doc.internal.pageSize.getHeight();

      if (typeof doc.putTotalPages === "function") {
        pageNumber += " of " + totalPagesExp;
      }

      doc.setFontSize(10);
      doc.text(pageNumber, data.settings.margin.left, pageHeight - 10);

      doc.addImage(
        eatprestoLogoImg,
        "JPEG",
        data.settings.margin.left + 144,
        pageHeight - 24,
        40,
        16,
      );
    },

    margin: { top: 30, bottom: 30 },
  });

  if (typeof doc.putTotalPages === "function") {
    doc.putTotalPages(totalPagesExp);
  }
};

/**
 * Main export: builds the PDF
 */
export const handleDownloadPdf = (
  filterDetails: string,
  pdfHeader: any[],
  nodes: Record<string, any>,
) => {
  const doc: any = new jsPDF("p");
  const today = moment().format("MMM_Do_YY").toString();

  let startY = 65;

  Object.entries(nodes).forEach(([key, value]: [string, any]) => {
    if (!_.isEmpty(value)) {
      if (startY > 240) {
        doc.addPage();
        startY = 30;
      }

      startY += 8;
      handleConvertPdf(doc, filterDetails);

      doc.setFontSize(12);
      doc.text(value.name, 14, startY); // ✅ use key as table title
 startY += 8;
      doc.text(
        "Note:  This report is generated for the selected location only, as reward item selections may",
        14,
        startY,
      ); // ✅ use key as table title
 startY += 4;
   doc.text(
        "differ across locations.",
        14,
        startY,
      ); // ✅ use key as table title
      handleTableInfo(
        key,
        doc,
        pdfHeader,
        [...value.body, value.footer],
        startY + 6,
        pdfHeader.length - 1,
      );

      startY = doc.lastAutoTable.finalY + 8;
    }
  });

  doc.save(
    `Reward_Choices_Report_${today}_${Math.floor(
      100000 + Math.random() * 900000,
    )}.pdf`,
  );
};
